<template>
    <div class="exchangeDiscount">
        <p class="smallTitle"><span class="couponA" @click="goToIntegral()">{{$t("discount")}}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="integralA">{{$t('integration')}}</span></p>
        <div class="discount_count">
            <!-- <p><span>兑换说明</span></p> -->
            <p><span></span></p>
            <h1>{{totalPoints}}<span>{{$t("score")}}</span></h1>
            <small>{{$t('total_score')}}</small>
        </div>
        <exchange-coupon ></exchange-coupon>
        <div class="exchangeDiscount_table">
            <table border="0" cellpadding="0" cellspacing="0">
                <tr>
                    <th>{{$t('date')}}</th>
                    <th>{{$t('unused_score')}}</th>
                    <th>{{$t('used_score')}}</th>
                    <th>{{$t('detail_info')}}</th>
                </tr>
                <tr v-for="(logInfo,index) in accountLog" :key="index">
                    <td>{{timestampToTime(logInfo.change_time)}}</td>
                    <td>{{logInfo.points}}</td>
                    <td>{{logInfo.pay_points}}</td>
                    <td>{{logInfo.desc}}</td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import { Toast } from "mint-ui";
import exchangeCoupon from "../../components/personalCenter/exchangeCoupon";
export default {
  name: "exchangeDiscount",
  inject: ["reload", "showMsg"],
  data: function() {
    return {
      accountLog: "", //兑换记录
      totalPoints: "" //总积分
    };
  },
  components: {
    exchangeCoupon
  },
  created() {
    this.$store.commit("set_current", "-1");
    this.$store.commit("set_title", "card_bag");
    this.getCreditsInfo();
  },
  computed: {
    weburl: function() {
      return this.$store.state.weburl;
    },
    hurl: function() {
      return this.$store.state.hurl;
    }
  },
  methods: {
    goToIntegral: function() {
      this.$router.push({ path: "/discount" });
    },
    // 获取积分的兑换记录
    getCreditsInfo: function() {
      this.$http({
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        method: "post",
        url: this.weburl + this.hurl + "/user/account",
        dataType: "json",
        data: {}
      })
        .then(res => {
          if (res.data.status == 1) {
            this.accountLog = res.data.result.account_log;
            this.totalPoints = res.data.result.pay_points;
          } else {
            Toast(res.data.mag);
          }
        })
        .catch(err => {
          Toast("系统错误,请稍后再试!");
        });
    },
    // 格式化时间
    timestampToTime: function(timestamp) {
      var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D = date.getDate() + " ";
      return Y + M + D;
    }
  }
};
</script>

<style scoped lang="less">
@import "../../assets/less/common.less";

.discount_count {
  padding-top: 10px;
  width: 100%;
  height: 170px;
  text-align: center;
  .box-sizing;
  p {
    height: 30px;
    padding-right: 20px;
    span {
      float: right;
      font-size: @font - 0.1;
      color: @brick_red;
    }
  }
  h1 {
    font-weight: normal;
    height: 4.5rem;
    font-size: @font * 4;
    span {
      font-size: @font;
    }
  }
}
.exchangeDiscount_table {
  width: 95%;
  margin: auto;
  border-top: 1px solid tint(@word, 50%);
  padding-top: 10px;
  table {
    width: 100%;

    th {
      width: 25%;
      background: tint(@word, 50%);
      height: 47px;
      line-height: 47px;
      color: @brick_red;
      font-size: @font;
      text-align-last: justify;
    }
    td {
      width: 25%;
      height: 40px;
      background: @bg;
      font-size: 0.8rem;
      text-align: center;
    }
  }
}
.smallTitle {
  font-size: 1.2rem;
  padding-left: 20px;
  margin-top: 54px;
  z-index: 1000;
}
.couponA {
  // color: #802629;
  font-weight: 600;
  color: #7f7e84;
}
.integralA {
  // color: #7f7e84;
  font-weight: 600;
  color: #802629;
}
.exchangeDiscount {
  .media;
}
</style>
